const sentryConfig = {
  dsn: process.env.REACT_APP_DSN_SENTRY,
  environment: process.env.REACT_APP_ENV_SENTRY,
  maxBreadcrumbs: 10
};

export default sentryConfig;
